import {
	GET_VOUCHERS,
	DELETE_VOUCHERS,
	GET_BATCH,
	GET_BATCHES,
	ADD_BATCH,
	UPDATE_BATCH,
	REMOVE_BATCH,
	ERR_BATCH,
	ERR_VOUCHERS,
	LOADING_VOUCHERS,
} from "../actions/actionTypes";
import { reducersActions } from "../actions/new-actions/index";
const {
  GET_BATCHES_REQUEST,
  GET_BATCHES_SUCCESS,
  GET_BATCHES_FAILURE,
} = reducersActions;

const initialState = {
	voucherBatch: null,
	voucherBatches: [],
	// loading: true,
	loading: false,
	errors: {},
	voucherCodes: [],
};

export default function voucherBatchReducer(state = initialState, action) {
	const { type, payload } = action;

	switch (type) {
		case GET_BATCHES:
			return {
				...state,
				voucherBatches: payload,
				loading: false,
			};
		case GET_BATCHES_SUCCESS:
			return {
				...state,
				voucherBatch: payload,
				loading: false,
			};
		case UPDATE_BATCH:
			return {
				...state,
				voucherBatches: state.voucherBatches.map((voucherBatch) =>
					voucherBatch.brand_id === payload.brand_id
						? { ...voucherBatch, payload }
						: voucherBatch
				),
				loading: false,
			};
		case ADD_BATCH:
			return {
				...state,
				voucherBatches: [payload.data, ...state.voucherBatches],
				loading: false,
			};
		case REMOVE_BATCH:
			return {
				...state,
				voucherBatches: state.voucherBatches.filter(
					(voucherBatch) => voucherBatch.brand_id !== payload
				),
				loading: false,
			};
		case ERR_BATCH:
			return {
				...state,
				errors: payload,
				loading: false,
				profile: null,
			};
		case GET_VOUCHERS:
			return {
				...state,
				voucherCodes: payload,
				loading: false,
			};
		case DELETE_VOUCHERS:
			return {
				...state,
				voucherCodes: state.voucherCodes.filter(
					(voucherCode) => voucherCode.voucher_id !== payload
				),
				loading: false,
			};
		case ERR_VOUCHERS:
			return {
				...state,
				error: payload,
				loading: false,
				profile: null,
			};
		case LOADING_VOUCHERS:
			return {
				...state,
				loading: payload
			};
		default:
			return state;
	}
}
